const apiUrl = process.env.REACT_APP_API_URL;

export const PutJutgeActivitatProblemes = async (id_activitat: string, problemIds: number[]) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/activitats/${id_activitat}/problemes`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(problemIds)
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error al guardar els exercicis de l\'activitat de Jutge:', error);
        throw error;
    }
};

